import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import PageNavigation from "./page";

export default function PracticeQuestionListPage({ heading, questionTitle }) {
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading={heading} questionTitle={questionTitle} />
    </div>
  );
}
